import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { Spin } from "antd";

import Blocks from "./components/Blocks";
import Legend from "./components/Legend";
import { ChartContainer } from "./styles";
import "./overview.css";
import { getUrl, requests } from "../../globals/requests";
import { helpers } from "../../utils";

function Overview() {
  const [summary, setSummary] = useState({});
  const [chartData, setChartData] = useState([]);
  const [loadingChartData, setLoadingChartData] = useState(false);

  useEffect(() => {
    async function getSummary() {
      try {
        const url = `${getUrl("users")}/summary`;
        const params = {};
        const response = await requests.getWithAuth(url, params);
        setSummary(response.data);
      } catch (e) {
        helpers.displayMessage(e);
      }
    }

    async function getChartData() {
      try {
        const url = `${getUrl("users")}/chartsummary`;
        setLoadingChartData(true);
        const response = await requests.getWithAuth(url);
        setLoadingChartData(false);
        setChartData(response.data);
      } catch (e) {
        setLoadingChartData(false);
        helpers.displayMessage(e);
      }
    }

    getSummary();
    getChartData();
  }, []);

  function renderChart() {
    if (loadingChartData) {
      return (
        <div className="spin-contain">
          <Spin delay={100} size="large" tip="Loading Chart... " />
        </div>
      );
    }
    return (
      <>
        <div className="ovv-chart-detail">
          <p>
            Chart showing Savings, Investments and Loans for all users onboarded
            for a period of 6 months
          </p>
        </div>
        <Legend />
        <LineChart
          width={1150}
          height={300}
          data={chartData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid
            // horizontal={false}
            vertical={false}
            strokeDasharray="3 3"
          />
          <XAxis axisLine={false} dataKey="name" />
          <YAxis axisLine={false} />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="savings"
            isAnimationActive={true}
            animationBegin={5000}
            // stroke="#8884d8"
            stroke="rgb(215, 154, 233)"
            strokeWidth={3}
            activeDot={{ r: 8 }}
          />
          <Line
            type="monotone"
            strokeWidth={3}
            animationBegin={5000}
            stroke="rgb(106, 233, 148)"
            dataKey="investments"
            // stroke="#82ca9d"
          />
          <Line
            type="monotone"
            strokeWidth={3}
            animationBegin={5000}
            stroke="rgb(138, 3, 3)"
            dataKey="loans"
            // stroke="#82ca9d"
          />
        </LineChart>
      </>
    );
  }

  return (
    <div>
      <Blocks summary={summary} />
      <ChartContainer>{renderChart()}</ChartContainer>
    </div>
  );
}

export default Overview;
